import React from 'react';

const LoginBtn = () => {
  return (
    <button className="header__right-item" tabIndex="2">LOGIN</button>
  );
};

export default LoginBtn;
